import React, { useState, useEffect } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import moment from 'moment'
import useWindow from '../../hooks/useWindow'
import { singleChartWidth, chartHeight, post2, list2 } from '../../services';
import exportingModule from "highcharts/modules/exporting";
import exportDataModule from 'highcharts/modules/export-data'
exportingModule(Highcharts);
exportDataModule(Highcharts);

export const FlowsChart = ({ data }) => {

    const [options, setOptions] = useState({})
    const size = useWindow()

    const [exp, setExp] = useState(false)
    useEffect(() => {
        async function fetch() {
            const auth = await list2('auth')
            setExp(auth === true)
        }
        fetch()
    }, [])

    useEffect(() => {
        const { columns, lines, title, subtitle, categories } = data
        const currentMonth = moment().format('YYYY-MM-01')
        const options = {
            chart:  { 
                width: singleChartWidth(size.width),
                height: chartHeight(size.height, 200)
            },
            exporting: exp ? {
                buttons: {
                    contextButton: {
                        enabled: true,
                        align: 'left',
                        menuItems: ["downloadPNG", "downloadPDF", "downloadCSV", "separator",
                            {   
                                text: 'Send Email', 
                                onclick: function() {
                                    const csv = this.getCSV()
                                    const html = this.getSVG()
                                    const title = this.getFilename()
                                    post2('user/export_file', { csv, html, title })
                                } 
                            }
                        ]
                    }
                }
            } : {
                buttons: {
                    contextButton: {
                        enabled: false
                    }    
                }
            },
            title: {
                text: title,
                useHtml: true,
                align: 'center'
            },
            subtitle: {
                text: subtitle,
                align: 'right'
            },
            xAxis: {
                title: { text: '' },
                categories: categories.map(({ x }) => x)
            },
            legend:{
                maxHeight: 150
            },
            yAxis: {
                title: {
                    text: ''
                },
                stackLabels: {
                    enabled: true,
                    crop: false,
                    overflow: 'allow',
                    style: {
                        fontWeight: 'bold',
                        color: 'gray'
                    }
                }
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: false
                    }
                }
            },
            series: [
                ...(lines ? [
                    {
                        name: 'Total',
                        type: 'spline',
                        data: lines.actual_total
                    },
                    {
                        name: 'Forward Est.',
                        type: 'spline',
                        data: lines.forward_est,
                        dashStyle: "LongDash"
                    },
                    {
                        name: '5Y Median',
                        type: 'spline',
                        data: lines.median,
                    },
                    {
                        name: '5Y',
                        type: 'areasplinerange',
                        fillOpacity: 0.3,
                        marker: { enabled: false },
                        data: lines.range.map(({ y }) => y),
                    },
                ] : []),
                ...columns.map((dat, i) => ({
                    type: 'column',
                    name: dat.name,
                    data: dat.data,
                }))
            ]
        }
        setOptions(options)
        console.log(options)
    }, [data, size, exp]);

    return (<div>
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />
    </div>)
}